/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InsurancesFormAliases {
  AUTOCOMPLETE_CATEGORY = 'autocomplete-category',
  AUTOCOMPLETE_INSURANCE = 'autocomplete-insurance',
  AUTOCOMPLETE_PLAN = 'autocomplete-plan',
  DATE_FIELD_WALLET_EXPIRY_DATE = 'date-field-wallet-expiry-date',
  FETCH_CATEGORY = 'fetch-category',
  FETCH_INSURANCE = 'fetch-insurance',
  FETCH_PLAN = 'fetch-plan',
  FIELD_CATEGORIA = 'field-categoria',
  FIELD_CONVENIO = 'field-convenio',
  FIELD_HEALTH_CARD_NUMBER = 'field-health-card-number',
  FIELD_INSURANCES = 'field-insurances',
  FIELD_PLANO = 'field-plano',
  FIELD_WALLET_EXPIRY_DATE = 'field-wallet-expiry-date',
  FORM_INSURANCES = 'form-insurances',
  INPUT_HEALTH_CARD_NUMBER = 'input-health-card-number',
  INSURANCES_FIELD_LIST = 'insurances-field-list',
  LAYOUT_INSURANCES_INSURANCE_FORM = 'layout-insurances-insurance-form',
  MAPPER_CATEGORY = 'mapper-category',
  MAPPER_INSURANCE = 'mapper-insurance',
  MAPPER_PLAN = 'mapper-plan',
  PANEL_GENERAL = 'panel-general',
  TEXT_CATEGORY = 'text-category',
  TEXT_INSURANCE = 'text-insurance',
  TEXT_PLAN = 'text-plan',
}
export { InsurancesFormAliases };
